import usePrivateAxios from '@/common/api/usePrivateAxios'
import { EquipmentCategoryData, EquipmentCategoryResponse } from '@/features/equipmentModels/types/equipmentCategories'
import { UseQueryResult, useQuery } from '@tanstack/react-query'

export const useEquipmentCategory: (id: string) => UseQueryResult<EquipmentCategoryData, unknown> = (id) => {
  const privateAxios = usePrivateAxios()

  return useQuery<EquipmentCategoryResponse, unknown, EquipmentCategoryData>({
    queryKey: ['equipmentCategory', id],
    queryFn: () => privateAxios.get(`/equipment_categories/${id}`),
    select: (data) => data?.data?.data,
  })
}
